import React from 'react';
import classNames from 'classnames';
import { Dialog, DialogContent } from './Dialog/Dialog';
import { Icons } from './BootstrapComponents';
import './ImagePreviewModal.scss';

export default function ImagePreviewModal(props) {
  const {
    open = false,
    imageUrl = '',
    title = 'Просмотр изображения',
    onClose = () => {},
  } = props;

  return (
    <Dialog
      className="image-preview-modal"
      onClose={onClose}
      size="xl"
      open={open}
    >
      <DialogContent className="image-preview-modal-content" onMouseDown={event => event.stopPropagation()}>
        <div className="image-preview-modal-header">
          <div className="image-preview-modal-title">{title}</div>
          <Icons width={14} height={14} customIcon icon="clear" className="image-preview-modal-close" onClick={onClose} />
        </div>
        <div className="image-preview-modal-body" onMouseDown={event => event.stopPropagation()}>
          <img
            className={classNames('image-preview-modal-image', { empty: !imageUrl })}
            src={imageUrl || ''}
            alt={title}
            onMouseDown={event => event.stopPropagation()}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
